import React from "react";
import {useTranslation} from "@unibuddy/intl";
import {CardBodySection} from "@unibuddy/buddycard-ui";

import {IntlNamespaces} from "../../../../../translations/types";

export type MentorFieldUIProps = {
    translationKey: string;
    defaultLabel: string;
    fieldValue?: string | JSX.Element;
};

export const MentorFieldUI = ({translationKey, defaultLabel, fieldValue}: MentorFieldUIProps) => {
    const {t} = useTranslation(IntlNamespaces.MENTOR_CARD);

    if (!fieldValue) return null;

    return (
        <CardBodySection
            heading={defaultLabel ? t(translationKey, defaultLabel) : null}
            content={fieldValue}
        />
    );
};
